import { render, staticRenderFns } from "./SignInOrUpDialog.vue?vue&type=template&id=59ac7dd0"
import script from "./SignInOrUpDialog.vue?vue&type=script&lang=ts"
export * from "./SignInOrUpDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports